export default "__VITE_ASSET__BWfECVSX__"